module.exports = __webpack_public_path__ + "img/svg/background-error.9be37ad68870265b947d9910d520e309.svg";